import React from 'react';
import styles from '../Rooms.module.css';

const HotspotIcon = ({ index, triggerZoomIcon, linkToProduct }) => {
  const tapForMoreInformation = () => {
    triggerZoomIcon(index, linkToProduct);
  };
  return (
    <div
      className={`${styles.outerContainerHotspotIcon} hotspot-icon`}
      id={`mobileIcon${index}`}
      onClick={tapForMoreInformation}
    >
      <div className={`${styles.outerHotspotIcon} hotspot-icon`}>
        <div
          id={`icon${index}`}
          className={`${styles.hotspotIcon} hotspot-icon`}
        ></div>
      </div>
    </div>
  );
};

export default HotspotIcon;
